import { useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { FaTimes } from "react-icons/fa";
import DateInput from "../DateInput";

const SearchAndFilter = ({
  componentId = "search-and-filter",
  searchTerm,
  setSearchTerm,
  dateRange,
  setDateRange,
  title = "Items",
  searchPlaceholder = "Search by name...",
  addButtonText = "Add Item",
  showAddButton = true,
  onAddClick,
  isLoading = false,
}) => {
  const [searchBy, setSearchBy] = useState("name");
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || "");

  const handleSearchChange = (e) => {
    setLocalSearchTerm(e.target.value);
  };

  const handleDateChange = (date, field) => {
    const updated = {
      ...dateRange,
      [field]: date ? date.toISOString().split("T")[0] : "",
    };
    setDateRange(updated);
  };

  const performSearch = () => {
    if (searchBy === "name" && localSearchTerm.trim().length < 2) {
      toast.error("Minimum 2 characters required");
      return;
    }

    setSearchTerm(localSearchTerm);
  };
  const clearDateRange = () => {
    setDateRange({ from: "", to: "" });
  };

  return (
    <div className={`mb-3 ${componentId}`}>
      <div className="d-flex justify-content-between align-items-center mb-2 d-md-none">
        <h4 className="mb-0 custom-title">{title}</h4>

        {showAddButton && (
          <button className="btn btn-primary btn-sm" onClick={onAddClick}>
            {addButtonText}
          </button>
        )}
      </div>

      <div className="row g-2 align-items-center">
        {/* Desktop Title */}
        <div className="col-md-4 d-none d-md-block">
          <h4 className="mb-0 custom-title">{title}</h4>
        </div>

        <div className="col-12 col-md-8">
          <div className="d-flex flex-column flex-md-row gap-2 justify-content-md-end align-items-md-center">
            {/* Row 2 Mobile - Dropdown Full Width */}
            <div
              className="w-100 w-md-auto"
              style={{ minWidth: "120px", maxWidth: "150px" }}
            >
              <select
                className="form-select form-select-sm search-height"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
              >
                <option value="name">Name</option>
                <option value="dateRange">Date Range</option>
              </select>
            </div>

            {/* Row 3 Mobile - Search Input */}
            <div
              className={`${searchBy === "dateRange" ? "flex-grow-1" : ""} position-relative`}
            >
              <div className="flex-grow-1">
                {searchBy === "name" && (
                  <div className="d-flex align-items-center gap-2">
                    {/* Input Wrapper */}
                    <div className="position-relative md:w-100">
                      <input
                        type="text"
                        className="form-control form-control-sm pe-4"
                        placeholder={searchPlaceholder}
                        value={localSearchTerm}
                        onChange={handleSearchChange}
                        onKeyDown={(e) => e.key === "Enter" && performSearch()}
                      />

                      {localSearchTerm && (
                        <FaTimes
                          className="position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                          style={{ cursor: "pointer", fontSize: "14px" }}
                          onClick={() => {
                            setLocalSearchTerm("");
                            setSearchTerm("");
                          }}
                        />
                      )}
                    </div>

                    {/* Search Icon OUTSIDE input */}
                    <span
                      className="text-muted d-inline d-md-none"
                      style={{ cursor: "pointer", fontSize: "18px" }}
                      onClick={performSearch}
                      title="Search"
                    ></span>
                  </div>
                )}
              </div>

              {/* Date Range WITHOUT DASH */}
              {searchBy === "dateRange" && (
                <div className="d-flex flex-column flex-md-row gap-2 w-100 align-items-start">
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{ minWidth: "260px" }}
                  >
                    <DateInput
                      value={dateRange?.from}
                      onChange={(val) =>
                        setDateRange({ ...dateRange, from: val })
                      }
                    />

                    <span className="mx-1">to</span>

                    <DateInput
                      value={dateRange?.to}
                      onChange={(val) =>
                        setDateRange({ ...dateRange, to: val })
                      }
                    />
                  </div>
                </div>
              )}
            </div>

            {/* Desktop Search Button */}
            <button
              className="btn btn-custom btn-sm d-none d-md-inline-block  search-height"
              disabled={isLoading}
              onClick={performSearch}
            >
              Search
            </button>
            {(dateRange?.from || dateRange?.to) && (
              <button
                type="button"
                className="btn btn-custom btn-sm d-flex align-items-center p-2"
                onClick={clearDateRange}
              >
                Clear
              </button>
            )}
            {/* Desktop Add Button */}
            {showAddButton && (
              <button
                className="btn btn-primary btn-sm d-none d-md-inline-block text-nowrap search-height"
                onClick={onAddClick}
              >
                {addButtonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

SearchAndFilter.propTypes = {
  componentId: PropTypes.string,
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  dateRange: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
  }).isRequired,
  setDateRange: PropTypes.func.isRequired,
  title: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  addButtonText: PropTypes.string,
  showAddButton: PropTypes.bool,
  onAddClick: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default SearchAndFilter;
